import { render, staticRenderFns } from "./thresholdCard.vue?vue&type=template&id=54317f22&scoped=true"
import script from "./thresholdCard.vue?vue&type=script&lang=js"
export * from "./thresholdCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54317f22",
  null
  
)

export default component.exports